"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRemoteCommandInvoker = void 0;
const RemoteCommandInvoker_1 = require("./RemoteCommandInvoker");
const RpcRequestBuilder_1 = require("../RpcRequestBuilder");
const RpcRequest_1 = require("../RpcRequest");
const cq_core_1 = require("@leavy/cq-core");
/**
 * RPC Command invoker using HTTP as transport
 */
class HttpRemoteCommandInvoker extends RemoteCommandInvoker_1.RemoteCommandInvoker {
    constructor(configProvider, axiosHttp, ambientValueInjector = new cq_core_1.DefaultAmbientValueInjector()) {
        super(RpcRequest_1.RequestProtocol.Http, new RpcRequestBuilder_1.RpcRequestBuilder([configProvider], axiosHttp), ambientValueInjector);
    }
}
exports.HttpRemoteCommandInvoker = HttpRemoteCommandInvoker;
//# sourceMappingURL=HttpRemoteCommandInvoker.js.map